import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KYMW1704Component } from './kymw1704.component';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { FileUploadService } from '../../../commons/kymw02/file-upload/file-upload.service';

import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { FormsModule } from '@angular/forms';
import { GetSupplierNameService } from './api-services/get-supplier-name.service';
import { GetPcodeDataService } from './api-services/get-pcode-data.service';
import { GetImageInfoService } from './api-services/get-image-info.service';
import { GetImageNameService } from './api-services/get-image-name.service';
import { GetBillingNameService } from './api-services/get-billing-name.service';
import { RegistImageSingleService } from './api-services/regist-Image-single.service';
import { ReplaceImageFileService } from './api-services/replace-image-file.service';
import { ReplaceImageFileUploadService } from './api-services/replace-image-file-upload.service';


/**
 * 画像個別登録画面 モジュール設定クラス
 *
 * @export KYMW1704Module
 * @class KYMW1704Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjInputModule,
  ],
  declarations: [
    KYMW1704Component,
  ],
  providers: [
    GetSupplierNameService,
    GetPcodeDataService,
    GetImageInfoService,
    GetImageNameService,
    GetBillingNameService,
    RegistImageSingleService,
    ReplaceImageFileService,
    ReplaceImageFileUploadService,
    FileUploadService,
  ],
})

export class KYMW1704Module { }
